/* ---------------------------------------------------------------------------
 * Designer Plants USA - side cart behaviour (window.dpCart)
 * ------------------------------------------------------------------------- */
window.dpCart = window.dpCart || (function () {
  var ADD_URL = (window.routes && window.routes.cartAddUrl) || '/cart/add';

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  }

  return {
    close: function () {
      var form = document.getElementById('mini-cart');
      if (!form) { return; }
      var toggle = document.querySelector('[aria-controls="mini-cart"]');
      if (toggle) { toggle.click(); return; }
      form.setAttribute('aria-hidden', 'true');
    },

    scroll: function (btn, dir) {
      var wrap = btn.closest('.dp-xs');
      var rail = wrap ? wrap.querySelector('.dp-xs__rail') : null;
      if (!rail) { return; }
      var first = rail.firstElementChild;
      var step = first ? first.getBoundingClientRect().width + 12 : rail.clientWidth;
      rail.scrollBy({ left: dir * step, behavior: 'smooth' });
    },

    add: function (btn) {
      if (btn.disabled) { return; }
      var id = btn.getAttribute('data-variant-id');
      if (!id) { return; }
      var label = btn.textContent;
      var err = btn.parentNode ? btn.parentNode.querySelector('[data-dp-xs-error]') : null;
      if (err) { err.hidden = true; }
      btn.disabled = true;
      btn.textContent = 'Adding';

      fetch(ADD_URL + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () {
          btn.textContent = 'Added';
          btn.classList.add('is-added');
          refresh();
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.textContent = label;
          if (err) { err.hidden = false; }
        });
    },

    discount: function (btn) {
      var foot = btn.closest('.dp-foot');
      var input = foot ? foot.querySelector('[data-dp-disc-input]') : null;
      var msg = foot ? foot.querySelector('[data-dp-disc-msg]') : null;
      if (!input) { return; }
      var code = (input.value || '').trim();
      if (!code) { return; }

      var before = 0;
      btn.disabled = true;
      btn.textContent = '...';
      if (msg) { msg.hidden = true; msg.className = 'dp-foot__disc-msg'; }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          before = c.total_price;
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var applied = (c.discount_applications && c.discount_applications.length > 0) ||
                        (c.total_price < before);
          btn.disabled = false;
          btn.textContent = 'Apply';
          if (msg) {
            msg.hidden = false;
            msg.className = 'dp-foot__disc-msg ' + (applied ? 'is-ok' : 'is-err');
            msg.textContent = applied ? 'Code applied' : 'That code is not valid for this order';
          }
          if (applied) { input.value = ''; refresh(); }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Apply';
          if (msg) {
            msg.hidden = false;
            msg.className = 'dp-foot__disc-msg is-err';
            msg.textContent = 'Could not apply that code. Please try again.';
          }
        });
    }
  };
})();

/* ---------------------------------------------------------------------------
 * Drawer auto-open and per-line savings.
 * The persistent MutationObserver is scoped to the current cart drawer only.
 * When Shopify replaces the drawer after cart:refresh, short re-arm timers find
 * the new drawer and attach a new scoped observer. Nothing watches document.body.
 * ------------------------------------------------------------------------- */
(function () {
  if (window.dpDrawerHook) { return; }
  window.dpDrawerHook = true;

  function isAddUrl(url) {
    try {
      return String(url).indexOf('/cart/add') !== -1;
    } catch (e) { return false; }
  }

  function openDrawer() {
    var form = document.getElementById('mini-cart');
    if (!form) { return; }
    if (form.getAttribute('aria-hidden') === 'false') { return; }
    var toggle = document.querySelector('[aria-controls="mini-cart"]');
    if (toggle) { toggle.click(); }
  }

  function amount(text) {
    var n = parseFloat(String(text).replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? null : n;
  }
  function symbol(text) {
    var m = String(text).match(/^[^0-9]*/);
    return m ? m[0].trim() : '$';
  }
  function fmt(sym, n) {
    return sym + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function markLineSavings() {
    var lists = document.querySelectorAll('.dp-cart .mini-cart__price-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.querySelector('.dp-line-save')) { continue; }
      var was = list.querySelector('.price--compare');
      if (!was) { continue; }
      var now = null;
      var prices = list.querySelectorAll('.price');
      for (var j = 0; j < prices.length; j++) {
        if (!prices[j].classList.contains('price--compare')) { now = prices[j]; break; }
      }
      if (!now) { continue; }
      var a = amount(was.textContent);
      var b = amount(now.textContent);
      if (a === null || b === null || a <= b) { continue; }
      var tag = document.createElement('span');
      tag.className = 'dp-line-save';
      tag.textContent = 'Save ' + fmt(symbol(was.textContent), a - b);
      was.parentNode.insertBefore(tag, was.nextSibling);
    }
  }

  var cartObserver = null;
  var observedCart = null;
  var rearmTimers = [];
  var savingsTimer = null;

  function armCartObserver() {
    markLineSavings();
    if (!window.MutationObserver) { return; }
    var cart = document.querySelector('.dp-cart');
    if (!cart) { return; }
    if (cart === observedCart && cartObserver) { return; }
    if (cartObserver) { cartObserver.disconnect(); }
    observedCart = cart;
    cartObserver = new MutationObserver(function () {
      clearTimeout(savingsTimer);
      savingsTimer = setTimeout(markLineSavings, 40);
    });
    cartObserver.observe(cart, { childList: true, subtree: true });
  }

  function scheduleCartObserver() {
    for (var i = 0; i < rearmTimers.length; i++) { clearTimeout(rearmTimers[i]); }
    rearmTimers = [];
    armCartObserver();
    [80, 220, 500, 900].forEach(function (delay) {
      rearmTimers.push(setTimeout(armCartObserver, delay));
    });
  }

  function afterAdd() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    setTimeout(openDrawer, 60);
    setTimeout(openDrawer, 400);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (input && input.url) ? input.url : input;
      var method = (init && init.method) || (input && input.method) || 'GET';
      var watch = isAddUrl(url) && String(method).toUpperCase() === 'POST';
      var out = nativeFetch.apply(this, arguments);
      if (!watch) { return out; }
      return out.then(function (res) {
        if (res && res.ok) { afterAdd(); }
        return res;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.dpWatch = isAddUrl(url) && String(method).toUpperCase() === 'POST';
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.dpWatch) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) { afterAdd(); }
      });
    }
    return nativeSend.apply(this, arguments);
  };

  document.documentElement.addEventListener('cart:refresh', scheduleCartObserver);
  document.documentElement.addEventListener('product:added', scheduleCartObserver);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armCartObserver, { once: true });
  } else {
    armCartObserver();
  }
})();

/**
 * Include your custom JavaScript here.
 */
var coll = document.getElementsByClassName("collaps");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

const videoElements = document.querySelectorAll("video");
videoElements.forEach(video => {
  video.setAttribute("controlsList", "nodownload");
});

const liquidDivs = document.querySelectorAll('.liquid.bg-white-liquid');
liquidDivs.forEach(div => {
  const imageWithTextDiv = div.querySelector('.image-with-text');
  if ((imageWithTextDiv && imageWithTextDiv.innerHTML.trim() === '') || div.innerHTML.trim() === '') {
    div.style.display = 'none';
  }
});

var currentPageURL = window.location.href;
if (currentPageURL.includes("over-40-green-wall-to-choose-from")) {
  var galleryButton = document.querySelector('.gallery_button');
  if (galleryButton) { galleryButton.setAttribute('target', '_blank'); }
}

function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

if (isMobileDevice()) {
  var list = document.querySelector('.footer__linklist');
  if (list) {
    var newListItem = document.createElement('li');
    var newLinkItem = document.createElement('a');
    newLinkItem.href = 'tel:+1 786 723 3309';
    newLinkItem.className = 'footer__link-item link';
    newLinkItem.textContent = 'Call Us: +1 786 723 3309';
    newListItem.appendChild(newLinkItem);
    list.appendChild(newListItem);
  }
}
